export default "__VITE_ASSET__D8chM5z3__"